import template from './linearThumb.html';

export default {
  template,
  bindings: {
    initials: '<',
    background: '<',
  },
};
